export const ReportDownload = () => {
  return (
    <svg viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_144078_173716"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="41"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.1309 26.1895C40.6026 26.1895 40.9854 26.5722 40.9854 27.0439V35.7686C40.9853 37.1521 40.4353 38.4787 39.457 39.457C38.4787 40.4353 37.1521 40.9854 35.7686 40.9854H5.23145C3.84798 40.9853 2.52123 40.4353 1.54297 39.457C0.564714 38.4787 0.0146653 37.152 0.0146484 35.7686V27.0439C0.0146484 26.5722 0.397416 26.1895 0.869141 26.1895C1.34088 26.1895 1.72363 26.5722 1.72363 27.0439V35.7686C1.72365 36.699 2.0931 37.5911 2.75098 38.249C3.40886 38.9069 4.30106 39.2763 5.23145 39.2764H35.7686C36.699 39.2764 37.5911 38.9069 38.249 38.249C38.9069 37.5911 39.2773 36.699 39.2773 35.7686V27.0439C39.2773 26.5723 39.6592 26.1895 40.1309 26.1895ZM20.5 0C20.9717 0 21.3545 0.382749 21.3545 0.854492V25.7988L32.166 14.9883C32.4996 14.6549 33.0405 14.6548 33.374 14.9883C33.7073 15.3218 33.7073 15.8628 33.374 16.1963L21.1045 28.4658C20.771 28.7993 20.2301 28.7992 19.8965 28.4658L7.62695 16.1963C7.29338 15.8627 7.29338 15.3219 7.62695 14.9883C7.96053 14.6547 8.50139 14.6547 8.83496 14.9883L19.6455 25.7988V0.854492C19.6455 0.382749 20.0283 3.5434e-07 20.5 0Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_144078_173716)">
        <rect width="41" height="41" fill="currentColor" />
      </g>
    </svg>
  )
}
